import React from "react";
import LongContent from "./LongContent";

function LegalMedical(props) {
  return (
    <LongContent>
      <h1>Medical Disclaimer</h1>
      <p>
        Last updated March 31, 2022 Where "The Creator" is Parados Cerebral
        Solutions Inc. (“The Company”, "Ourselves", “we,” “us”, or “our”). Where
        “Products” include but are not limited to exercises, load management,
        educational videos, technique improvements, etc. Products are intended
        for educational and informative purposes only and are not intended to
        serve as medical or professional advice.
      </p>
      <p>
        Any risk associated with the Products is considered minimal. However,
        you should consult your physician or other health care professional
        before starting this or any other health and/or fitness program to
        determine if it is right for your unique needs. This is particularly
        true if you (or your family) have a history of high blood pressure or
        heart disease, or if you have ever experienced chest pain when
        exercising or have experienced chest pain in the past month when not
        engaged in physical activity, smoke, have high cholesterol, are obese,
        or have a bone or joint problem that could be made worse by a change in
        physical activity. Do not start this program if your physician or health
        care provider advises against it. If you experience faintness,
        dizziness, pain or shortness of breath at any time while exercising you
        should stop immediately. This program offers health, fitness and
        nutritional information and is designed for educational purposes only.
        You should not rely on this information as a substitute for, nor does it
        replace, professional medical advice, diagnosis, or treatment. The
        Creator shall have neither liability, nor responsibility, to any person
        or entity with respect to any of the information contained in the
        Products. The user assumes all risk for any injury, loss or damage
        caused or alleged to be caused, directly or indirectly by using any
        information described in this program. If you have any concerns or
        questions about your health, you should always consult with a physician
        or other health-care professional. Do not disregard, avoid or delay
        obtaining medical or health related advice from your health-care
        professional because of something you may have read on this program. The
        use of any information provided on this program is solely at your own
        risk. Developments in medical research may impact the health, fitness
        and nutritional advice that appears here. No assurance can be given that
        the advice contained in the program will always include the most recent
        findings or developments with respect to the particular material.
      </p>

      <h2>HOLD HARMLESS AGREEMENT:</h2>
      <p>
        Where “The Evaluator” is any representative(s) of Parados Cerebral
        Solutions Inc. and “Products” include but are not limited to exercises,
        load management, educational videos, technique improvements, etc.
        Products are intended for educational and informative purposes only and
        are not intended to serve as medical or professional advice. Always
        consult your doctor before making any changes to your rehabilitation,
        ergonomic, diet or nutrition program. No health claims are made for this
        program. The Products will not help cure, heal, or correct any illness,
        metabolic disorder, or medical condition. The Evaluator is not a medical
        doctor, physiotherapist, registered dietitian, or clinical nutritionist.
        The Evaluator shall have neither liability, nor responsibility, to any
        person or entity with respect to any of the information contained in the
        Products. The user assumes all risk for any injury, loss or damage
        caused or alleged to be caused, directly or indirectly by the evaluation
        and/or using any information described in this program.
      </p>
      <h2>WEBSITE DISCLAIMER</h2>
      <p>
        The information provided by Parados Cerebral Solutions Inc. ("The
        Company", "Ourselves", “we,” “us”, or “our”) on
        http://www.parados.app(the “Site”) and our web application is for
        general informational purposes only. All information on the Site and our
        web application is provided in good faith, however we make no
        representation or warranty of any kind, express or implied, regarding
        the accuracy, adequacy, validity, reliability, availability or
        completeness of any information on the Site or our web application.
        UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR
        DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR OUR
        WEB APPLICATION OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE AND
        OUR WEB APPLICATION. YOUR USE OF THE SITE AND OUR WEB APPLICATION AND
        YOUR RELIANCE ON ANY INFORMATION ON THE SITE AND OUR WEB APPLICATION IS
        SOLELY AT YOUR OWN RISK.
      </p>
      <h2>PROFESSIONAL DISCLAIMER </h2>
      <p>
        The Site cannot and does not contain fitness and/or medical/health
        advice. The fitness and/or medical/health information is provided for
        general informational and educational purposes only and is not a
        substitute for medical or professional advice. Accordingly, before
        taking any actions based upon such information, we encourage you to
        consult with the appropriate professionals. We do not provide any kind
        of medical/health or fitness advice. THE USE OR RELIANCE OF ANY
        INFORMATION CONTAINED ON THE SITE OR OUR MOBILE APPLICATION IS SOLELY AT
        YOUR OWN RISK.
      </p>
      <h2>EXTERNAL LINKS DISCLAIMER</h2>
      <p>
        The Site and our web application may contain (or you may be sent through
        the Site or our web application) links to other websites or content
        belonging to or originating from third parties or links to websites and
        features in banners or other advertising. Such external links are not
        investigated, monitored, or checked for accuracy, adequacy, validity,
        reliability, availability or completeness by us. WE DO NOT WARRANT,
        ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE ACCURACY OR
        RELIABILITY OF ANY INFORMATION OFFERED BY THIRD-PARTY WEBSITES LINKED
        THROUGH THE SITE OR ANY WEBSITE OR FEATURE LINKED IN ANY BANNER OR OTHER
        ADVERTISING. WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR
        MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF
        PRODUCTS OR SERVICES.
      </p>
      <h2>TESTIMONIALS DISCLAIMER</h2>
      <p>
        The Site may contain testimonials by users of our products and/or
        services. These testimonials reflect the real-life experiences and
        opinions of such users. However, the experiences are personal to those
        particular users, and may not necessarily be representative of all users
        of our products and/or services. We do not claim, and you should not
        assume, that all users will have the same experiences. YOUR INDIVIDUAL
        RESULTS MAY VARY. The testimonials on the Site are submitted in various
        forms such as text, audio and/or video, and are reviewed by us before
        being posted. They appear on the Site verbatim as given by the users,
        except for the correction of grammar or typing errors. Some testimonials
        may have been shortened for the sake of brevity where the full
        testimonial contained extraneous information not relevant to the general
        public. The views and opinions contained in the testimonials belong
        solely to the individual user and do nor reflect our views and opinions.
        We are not affiliated with users who provide testimonials, and users are
        not paid or otherwise compensated for their testimonials. The
        testimonials on the Site are not intended, nor should they be construed
        as claims that our products and/or services can be used to diagnose,
        treat, mitigate, cure, prevent or otherwise be used for any disease or
        medical condition. No testimonials have been clinically proven or
        evaluated.
      </p>
    </LongContent>
  );
}

export default LegalMedical;
